import * as React from "react";
import {
  Box,
  Typography,
  ListItem as MuiListItem,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  Avatar,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";

interface ListItemProps {
  title: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  secondary?: React.ReactNode;
  icon?: React.ReactNode;
  avatar?: string;
  rightContent?: React.ReactNode;
  onClick?: () => void;
  selected?: boolean;
  dense?: boolean;
  sx?: any;
  children?: React.ReactNode;
}

const StyledListItem = styled(MuiListItem, {
  shouldForwardProp: (prop) =>
    prop !== "selected" && prop !== "clickable",
})<{ clickable?: boolean }>(({ theme, clickable }) => ({
  borderRadius: theme.shape.borderRadius * 1.5,
  marginBottom: theme.spacing(0.5),
  transition: "all 0.2s ease-in-out",
  ...(clickable && {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      transform: "translateX(4px)",
    },
  }),
}));

const ListItem: React.FC<ListItemProps> = ({
  title,
  subtitle,
  secondary,
  icon,
  avatar,
  rightContent,
  onClick,
  selected = false,
  dense = false,
  sx,
  children,
}) => {
  return (
    <StyledListItem
      onClick={onClick}
      selected={selected}
      dense={dense}
      clickable={!!onClick}
      sx={sx}
    >
      {(icon || avatar) && (
        <ListItemAvatar>
          {avatar ? (
            <Avatar src={avatar} alt={typeof title === "string" ? title : undefined} />
          ) : (
            <Avatar>{icon}</Avatar>
          )}
        </ListItemAvatar>
      )}
      <ListItemText
        primary={
          <Typography
            variant="body1"
            fontWeight={selected ? 600 : 400}
            component="div"
          >
            {title}
          </Typography>
        }
        secondary={
          subtitle || secondary || children ? (
            <Box component="div">
            {subtitle && typeof subtitle === "string" && (
              <Typography variant="body2" color="text.secondary" component="span">
                {subtitle}
              </Typography>
            )}
              {subtitle && typeof subtitle !== "string" && <Box component="div" sx={{ mt: 0.5 }}>{subtitle}</Box>}
              {secondary && <Box component="div" sx={{ mt: 0.5 }}>{secondary}</Box>}
            {children}
          </Box>
          ) : undefined
        }
      />
      {rightContent && (
        <ListItemSecondaryAction>{rightContent}</ListItemSecondaryAction>
      )}
    </StyledListItem>
  );
};

export default ListItem;

